import _ from "lodash";
import {loadable} from "jotai/utils";
import {atomWithRefresh} from "../utils/jotaiUtils";
import {activeCompanyIdAtom} from "./activeCompanyStore";
import {Farm} from "../types/domain/farm";
import {getAllFarms} from "../services/farmService";

export const activeCompanyFarmsAtom = atomWithRefresh(async (get) => {
    const activeCompanyId = await get(activeCompanyIdAtom);
    let allFarms: Farm[] = [];

    if (activeCompanyId) {
        allFarms = await getAllFarms(activeCompanyId);
    }
    allFarms.sort(sortFarms);

    return {
        farms: allFarms,
        mapByFarmId: _.keyBy(allFarms, "id"),
    };
});

export const activeCompanyFarmsLoadable = loadable(activeCompanyFarmsAtom);

/**
 * Sorting farms by name, moving DEFAULT farm to the end of the list
 */
const sortFarms = (left: Farm, right: Farm) => {
    if (left.isDefault) {
        return 1;
    } else if (right.isDefault) {
        return -1;
    } else {
        return left.name.localeCompare(right.name);
    }
};
